<div class="chat-sheet" role="dialog" aria-modal="true" aria-label="New chat" (keydown.escape)="close()">
  <div class="chat-sheet__bar">
    <span class="chat-sheet__title">New chat</span>
    <button type="button" class="chat-icon-button chat-sheet__close" (click)="close()" aria-label="Close new chat"
            matTooltip="Close new chat"><i class="fa-regular fa-xmark" aria-hidden="true"></i></button>
  </div>

  <!-- The house search field at the sheet's width, matching the name and the address. -->
  <div class="chat-sheet__search">
    <div class="chat-search-field">
      <i class="fa-regular fa-magnifying-glass" aria-hidden="true"></i>
      <input #searchInput type="search" [value]="query" (input)="onSearch($any($event.target).value)"
             placeholder="Search by name or email" aria-label="Search people">
    </div>
  </div>

  <div class="chat-scroll">
    <ul class="chat-list" *ngIf="shown.length">
      <li class="chat-list__item" *ngFor="let member of shown; trackBy: trackByEmail">
        <!-- A label, so the whole row is the box's target rather than a 16px square beside it. -->
        <label class="chat-row chat-sheet__row">
          <input type="checkbox" class="chat-check" [checked]="isPicked(member)" (change)="togglePicked(member)"
                 [attr.aria-label]="member.name">
          <span class="chat-row__face" aria-hidden="true">
            <messenger-presence-face [status]="statusOf(member)" [size]="44">
              <ngx-stored-gravatar [email]="member.email" [name]="member.name" [style]="faceStyle"></ngx-stored-gravatar>
            </messenger-presence-face>
          </span>
          <span class="chat-row__text">
            <span class="chat-row__line"><span class="chat-row__name">{{ member.name }}</span></span>
            <span class="chat-row__line"><span class="chat-row__last">{{ member.email }}</span></span>
          </span>
        </label>
      </li>
    </ul>
    <div class="chat-empty" *ngIf="state === 'ready' && !shown.length" role="status">No people.</div>
    <div class="chat-empty" *ngIf="state === 'loading'" role="status">
      <mat-spinner diameter="24" aria-label="Loading people"></mat-spinner>
    </div>
    <div class="chat-empty" *ngIf="state === 'error'" role="alert">
      <span>Couldn't load people.</span>
      <button mat-stroked-button type="button" (click)="load()">Retry</button>
    </div>
  </div>

  <div class="chat-sheet__foot">
    <button mat-flat-button color="primary" type="button" class="chat-sheet__continue" [disabled]="!canContinue"
            (click)="continue()">Continue</button>
  </div>
</div>
